import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Libera a rota para usuários que podem ver os dashboards (Admin, Super ou Conciliador).
 * Espelha a policy "Dashboards.view" do backend. Admin e Conciliador veem o dashboard
 * escopado ao próprio cliente; Super vê todos.
 */
export const dashboardsViewGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isInitialized()) {
    await firstValueFrom(toObservable(authService.isInitialized).pipe(filter(Boolean)));
  }

  if (!authService.isAuthenticated()) {
    return router.parseUrl('/login');
  }

  if (!authService.canViewDashboards()) {
    return router.parseUrl('/projects');
  }

  return true;
};
